<template>
  <div class="subnavbar px-3">
    <v-breadcrumbs :items="breadcrumbs">
      <template v-slot:item="{ item }">
        <router-link
          class="subnavbar__back"
          :to="menuTo()"
          v-if="item.icon"
        >
          <v-icon color="primary">{{ item.icon }}</v-icon>
        </router-link>
        <span class="primary--text" v-else>{{ item.text }}</span>
      </template>

      <template v-slot:divider>
        <div class="subnavbar__divider"></div>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
import lang from '@/lang';

export default {
  name: 'app-subnavbar',
  props: {
    menu: Array,
  },
  computed: {
    parentId() {
      return this.$route.params.id;
    },
    actual() {
      return (this.menu.find(p => p.menu.guid === this.parentId) || {}).menu || {};
    },
    breadcrumbs() {
      return [
        {
          text: 'Home',
          icon: 'mdi-arrow-left',
        },
        {
          text: {
            en: this.actual.titleEN,
            fr: this.actual.titleFR,
          }[lang.locale] || this.actual.titleEN,
        },
      ];
    },
  },
  methods: {
    menuTo() {
      const id = this.actual.parentId;
      let name = 'menu.child';
      if (!id) name = 'menu.index';
      return { name, params: { id } };
    },
  },
};
</script>
